import { ref, Ref } from "@vue/composition-api";
import providers from "@/lib/api";

export const useCheckCreatorServices = (userId: Ref<string>) => {
  const loading = ref(false);
  const hasServices = ref(false);

  const checkServices = async () => {
    try {
      loading.value = true;
      const response = await providers.CreatorServicesProvider.search(
        {
          data: {
            userId: userId.value,
            deleted: false,
            size: 1,
          },
        },
        ["id"]
      );
      hasServices.value = response.totalRecords > 0;
    } finally {
      loading.value = false;
    }
  };

  return {
    loading,
    hasServices,
    checkServices,
  };
};
